import { makeStyles } from '@material-ui/core';
import hexToRgb from '../../helpers/ui/coloringHelper';

const useStyles = makeStyles((theme) => ({
  formSection: {
    border: `1px solid ${theme.palette.gray.formSectionBorder}`,
    borderRadius: 10,
    background: theme.palette.white.main,
    overflow: 'hidden',
    marginBottom: 30,
  },
  formSectionHeader: {
    minHeight: 64,
    background: `rgba(${hexToRgb(theme.palette.gray.formSectionBackground)}, 0.1)`,
    display: 'flex',
    alignItems: 'center',
    padding: 10,
    [theme.breakpoints.down('sm')]: {
      minHeight: 54,
    },
  },
  formSectionIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 8,
    marginRight: 20,
    padding: 7,
    border: `1px solid ${theme.palette.gray.formSectionBorder}`,
    background: theme.palette.white.main,
    [theme.breakpoints.down('sm')]: {
      marginRight: 10,
      padding: 6,
    },
  },
  icon: {
    width: 30,
    height: 30,
    [theme.breakpoints.down('sm')]: {
      width: 25,
      height: 25,
    },
  },
  formSectionTitle: {
    textTransform: 'uppercase',
    fontSize: 20,
    fontWeight: 600,
    [theme.breakpoints.down('sm')]: {
      fontSize: 13,
    },
  },

  formSectionContent: {
    padding: 30,
    [theme.breakpoints.down('sm')]: {
      padding: 16,
    },
  },
}));

export default useStyles;
